import { useEffect, useRef, useState } from "react";

export const useLiveDuration = (startTime, isActive) => {
  const [duration, setDuration] = useState("0s");
  const intervalRef = useRef(null);
  const calculate = () => {
    if (!startTime) return;
    const diffMs = Date.now() - new Date(startTime).getTime();
    const totalSeconds = Math.max(0, Math.floor(diffMs / 1000));

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (hours > 0) setDuration(`${hours}h ${minutes}m ${seconds}s`);
    else if (minutes > 0) setDuration(`${minutes}m ${seconds}s`);
    else setDuration(`${seconds}s`);
  };

  useEffect(() => {
    if (!startTime) return;

    if (isActive) {
      calculate();
      intervalRef.current = setInterval(calculate, 1000);
    } else {
      clearInterval(intervalRef.current);
    }

    return () => clearInterval(intervalRef.current);
  }, [startTime, isActive]);

  return duration;
};
